// extracted by mini-css-extract-plugin
export var actions = "recipe-note-module--actions--8BNjF";
export var container = "recipe-note-module--container--d2L35";
export var content = "recipe-note-module--content--4huBv";
export var date = "recipe-note-module--date--PQG68";
export var deleteButton = "recipe-note-module--delete-button--toCGO";